function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M2 5l6.667 3.185v6.5L2 11.5zM15.4 5L22 8.185 15.4 11.5z"
}), React.createElement("path", {
  opacity: 0.75,
  d: "M15.4 5L8.667 8.185v6.5L15.4 11.5zM22 8.185L15.4 11.5V18l6.6-3.315z"
}));

var SvgServiceLogoBuildkiteIcon = function SvgServiceLogoBuildkiteIcon(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgServiceLogoBuildkiteIcon;